import { Mark } from "@tiptap/react";

const CLARIFICATION_ID_ATTR = "clarificationId";
const CLARIFICATION_ID_DATA_ATTR = "data-clarification-id";
const CLARIFICATION_MARKER_DATA_ATTR = "data-clarification-anchor";

/**
 * Inline anchor mark used to bind selected text to clarification requests.
 *
 * Stores a stable clarification request ID in document JSON/HTML so highlights
 * can be recovered reliably after navigation and reloads.
 */
export const ClarificationAnchorMark = Mark.create({
  name: "clarificationAnchor",

  excludes: "",

  inclusive: false,

  addAttributes() {
    return {
      [CLARIFICATION_ID_ATTR]: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute(CLARIFICATION_ID_DATA_ATTR),
        renderHTML: (attributes: Record<string, unknown>) => {
          const clarificationId =
            typeof attributes[CLARIFICATION_ID_ATTR] === "string" &&
            attributes[CLARIFICATION_ID_ATTR].length > 0
              ? attributes[CLARIFICATION_ID_ATTR]
              : null;
          return clarificationId ? { [CLARIFICATION_ID_DATA_ATTR]: clarificationId } : {};
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: `span[${CLARIFICATION_ID_DATA_ATTR}]` }];
  },

  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, unknown> }) {
    return [
      "span",
      {
        ...HTMLAttributes,
        [CLARIFICATION_MARKER_DATA_ATTR]: "true",
      },
      0,
    ];
  },
});
